import React, { Component } from "react";

export default class AppBankStatement extends Component {
  constructor(props) {
    super(props);
    this.refs = {
      bankStatementForm: React.createRef(),
    };
    this.state = {};
    // this.bankFields = [
    //   {
    //     name: "bank1",
    //     label: "Bank 1",
    //     type: "select",
    //     options: BankList.options(),
    //     className: "fw-bold",
    //   },
    //   {
    //     name: "tenor",
    //     label: "Tenor",
    //     type: "select",
    //     options: Tenor.options(),
    //   },
    //   {
    //     name: "accType",
    //     label: "Type of A/C.",
    //     type: "select",
    //     options: AccountTypes.options(),
    //   },
    // ];
    // this.bankDynamicFields = [
    //   {
    //     name: "bankMonthDate",
    //     type: "select",
    //     options: MonthYear.options(),
    //   },
    //   {
    //     name: "tenorFile",
    //     type: "file",
    //     labelname: "Choose File",
    //   },
    //   {
    //     name: "sanctionLetter",
    //     type: "file",
    //     labelname: "Upload Sanction Letter",
    //   },
    // ];
  }
  render() {
    let { compId, editaccess } = this.props;
    let {
        AccountTypes,
        BankList,
        MonthYear,
        Tenor,
    } = enums;
    return (
      <>
        {/* {this.bankFields.map((field, i) => (
            <div className="col-sm-6 col-md-4 mb-4" key={i}>
              <AppInput {...field}></AppInput>
            </div>
          ))} */}

        <div className="col-sm-6 col-md-4 mb-4">
          <AppInput
            name={`bank_${compId}`}
            label={`Bank ${compId}`}
            type="select"
            options={BankList.options()}
            className="fw-bold"
          ></AppInput>
        </div>
        <div className="col-sm-6 col-md-4 mb-4">
          <AppInput
            name={`tenor_${compId}`}
            label="Tenor"
            type="select"
            options={Tenor.options()}
          ></AppInput>
        </div>
        <div className="col-sm-6 col-md-4 mb-4">
          <AppInput
            name={`accType_${compId}`}
            label="Type of A/C."
            type="select"
            options={AccountTypes.options()}
          ></AppInput>
        </div>

        <div className="row mx-0 dynamic_field_content">
          {/* {this.bankDynamicFields.map((field, i) => (
            <div className="col-sm-6 col-md-4" key={i}>
              <AppInput {...field}></AppInput>
            </div>
          ))} */}
          <div className="col-sm-6 col-md-4">
            <AppInput
              name={`bankMonthDate_${compId}`}
              type="select"
              options={MonthYear.options()}
              editaccess={editaccess}
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <AppInput
              name={`tenorFile_${compId}`}
              type="file"
              labelname="Choose File"
              editaccess={editaccess}
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <AppInput
              name={`sanctionLetter_${compId}`}
              type="file"
              labelname="Upload Sanction Letter"
              editaccess={editaccess}
            />
          </div>
        </div>
      </>
    );
  }
}